<section class="tags-wrapper">
  <div class="tags-container">
    <!-- Header: titolo + statistiche -->
    <header class="tags-header">
      <div class="title-block">
        <div class="title-block-row">
          <span class="title-icon material-symbols-outlined" aria-hidden="true">label</span>
          <div class="title-text">
            <h1 class="page-title">Tags</h1>
          </div>
        </div>
        <!-- Filtri categoria attivi -->
        <div class="selected-filters-container" *ngIf="selectedCategory">
          <span class="filter-chip">
            <span class="chip-label">{{ getCategoryName(selectedCategory) }}</span>
            <button
              type="button"
              class="chip-remove"
              (click)="clearFilter()"
              aria-label="Rimuovi filtro"
            >
              <i class="pi pi-times"></i>
            </button>
          </span>
        </div>
      </div>
      <div class="header-actions">
        <button
          pButton
          type="button"
          icon="pi pi-plus"
          label="Nuovo Tag"
          class="add-button p-button-rounded"
          aria-label="Aggiungi nuovo tag"
          (click)="openCreateTagDialog()"
          *ngIf="canModify()"
        ></button>
        <div class="stats-block">
          <div class="stat-card primary">
            <span class="stat-label">Numero di tags</span>
            <span class="stat-value">{{ filteredTags.length }}</span>
          </div>
        </div>
      </div>
    </header>

    <!-- Filtri categoria + filtro codice -->
    <section class="filters-section" *ngIf="categories.length > 0">
      <div class="filters-header">
        <span class="filters-label">
          <i class="pi pi-filter"></i>
          <span>Filtra per categoria</span>
        </span>
        <div class="filters-actions">
          <span class="code-search-wrapper">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                type="text"
                pInputText
                placeholder="Filtra per codice tag"
                [(ngModel)]="searchCodice"
                (ngModelChange)="onSearchCodiceChange($event)"
              />
            </span>
          </span>
          <button
            *ngIf="selectedCategory || searchCodice"
            type="button"
            class="clear-filter-btn clear-filter-btn--icon-only"
            (click)="clearFilter()"
            pTooltip="Rimuovi tutti i filtri"
            tooltipPosition="top"
            aria-label="Rimuovi filtri"
          >
            <i class="pi pi-filter-slash"></i>
          </button>
        </div>
      </div>
      <div class="category-filters">
        <button
          *ngFor="let category of categories"
          type="button"
          class="category-filter-chip"
          [class.active]="isCategorySelected(category.code)"
          [style.background-color]="isCategorySelected(category.code) ? getCategoryColor(category.code) : 'transparent'"
          [style.color]="isCategorySelected(category.code) ? getCategoryTextColor(category.code) : 'inherit'"
          [style.border-color]="getCategoryColor(category.code)"
          (click)="selectCategory(category.code)"
        >
          <span class="category-filter-label">{{ category.name | uppercase }}</span>
          <span class="category-filter-count">({{ category.count }})</span>
        </button>
      </div>
    </section>

    <!-- Sezione tabella -->
    <section class="table-section" *ngIf="tags.length > 0; else noTags">
      <div class="table-card">
        <div class="table-content">
          <p-table
            [value]="filteredTags"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            [resizableColumns]="true"
            [responsiveLayout]="'scroll'"
            [loading]="loading"
            class="tags-table"
            [sortField]="'categoriaTagCodice'"
            [sortOrder]="1"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pResizableColumn pSortableColumn="categoriaTagNome" style="min-width: 250px">
                  Categoria
                </th>
                <th pResizableColumn pSortableColumn="codice" style="min-width: 200px">
                  Codice
                </th>
                <th pResizableColumn style="min-width: 140px; text-align: center;">
                  Numero Referenze
                </th>
                <th style="width: 60px;"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tag>
              <tr>
                <td>
                  <span
                    class="category-badge"
                    [style.background-color]="getCategoryColor(tag.categoriaTagCodice)"
                    [style.color]="getCategoryTextColor(tag.categoriaTagCodice)"
                  >
                    {{ tag.categoriaTagNome | uppercase }}
                  </span>
                </td>
                <td>
                  <span class="tag-code">{{ tag.codice }}</span>
                </td>
                <td style="text-align: center;">
                  <span
                    class="referenze-count"
                    [class.clickable]="getReferenzeCount(tag) > 0"
                    [pTooltip]="getReferenzeCount(tag) > 0 ? 'Clicca per vedere le referenze con questo tag' : ''"
                    tooltipPosition="top"
                    (click)="navigateToHomeWithTag(tag)"
                  >
                    {{ getReferenzeCount(tag) }}
                  </span>
                </td>
                <td style="text-align: center;">
                  <button
                    *ngIf="getReferenzeCount(tag) === 0 && canModify()"
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger p-button-text p-button-rounded delete-tag-btn"
                    [pTooltip]="'Elimina tag'"
                    tooltipPosition="top"
                    (click)="confirmDeleteTag(tag)"
                    aria-label="Elimina tag"
                  ></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4" class="empty-message">
                  Nessun tag trovato
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
              <tr>
                <td colspan="4" class="loading-message">
                  <i class="pi pi-spin pi-spinner"></i>
                  Caricamento in corso...
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </section>

    <ng-template #noTags>
      <section class="empty-state">
        <div class="empty-card">
          <i class="pi pi-tags empty-icon"></i>
          <h2>Nessun tag disponibile</h2>
          <p>
            Non sono presenti tag nel database. Verifica la connessione al backend o contatta l'amministratore.
          </p>
        </div>
      </section>
    </ng-template>
  </div>
</section>

<!-- Dialog Creazione Tag (componente condiviso) -->
<app-create-tag-dialog
  [(visible)]="showCreateTagDialog"
  [tags]="tags"
  [preselectedCategory]="createTagInitialCategory"
  (tagCreated)="onTagCreated()"
></app-create-tag-dialog>

<!-- Confirm Dialog per eliminazione -->
<p-confirmDialog></p-confirmDialog>


